import Vue from 'vue'
import VueRouter from 'vue-router'
import { setVueRouter } from './proxy'

Vue.use(VueRouter)

const routes = []
const routesContexts = require.context('./routes', true, /\.js$/)
routesContexts.keys().forEach(name => routes.push(...routesContexts(name).default))

const router = new VueRouter({
  routes
})

setVueRouter(router)

export default router
